import { styled } from '../theme';

const PageTile = styled('div')(({ theme }) => ({
    background: theme.color.white,
    borderRadius: theme.borderRadius.base,
    paddingLeft: 30,
    paddingRight: 30,
}));

export default PageTile;
